import * as React from 'react';
export const IcGamingControllers = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.7 8.53a5.94 5.94 0 00-5.53-4H8a6 6 0 00-6 5.83c-.09 3.39 2.56 9.17 5.83 9.17 2.17 0 2.06-3.29 2.91-3.8a2.52 2.52 0 012.53 0c1 .57.74 3.8 3.29 3.8s5.24-5.64 5.44-8.61a5.69 5.69 0 00-.3-2.39zm-12 2.68a1 1 0 01-.7.29H8v1a1 1 0 01-.29.71 1 1 0 01-.71.29 1 1 0 01-1-1v-1H5a1 1 0 010-2h1v-1a1 1 0 011.384-.926 1 1 0 01.326.216A1 1 0 018 8.5v1h1a1 1 0 01.71 1.71H9.7zm6 0a1.001 1.001 0 01-1.26.12.91.91 0 01-.37-.45 1 1 0 01-.07-.58 1 1 0 01.648-.741 1 1 0 011.332.94 1 1 0 01-.27.71h-.01zm.59-3.42A.999.999 0 0117 7.5a1 1 0 01.93.62 1 1 0 01.07.58 1 1 0 01-.78.78 1 1 0 01-.58-.06 1 1 0 01-.45-.36A1 1 0 0116 8.5a.999.999 0 01.3-.71h-.01zm1.41 5.42a1.001 1.001 0 01-1.26.12.91.91 0 01-.37-.45 1 1 0 01-.07-.58 1 1 0 01.648-.741.999.999 0 011.332.94 1 1 0 01-.27.71h-.01zm2-2a1.001 1.001 0 01-1.26.12.91.91 0 01-.37-.45 1 1 0 01-.07-.58 1 1 0 01.648-.741 1 1 0 011.332.94 1 1 0 01-.27.71h-.01z'
      fill='currentColor'
    />
  </svg>
);
